import type * as api from '@gitbook/api-client';
import { useConfigurationTheme } from '@gitbook/react-uikit';

import { useContentReference } from './useContentReference';

export interface ImageURISource {
    uri: string;
    width?: number;
    height?: number;
}

/**
 * Resolve a content reference to an image source.
 * The image source is optimized to contain the width and height of the image.
 */
export function useImageContentReference(
    defaultContentRef: api.ContentRef | undefined,
    contentRefDark?: api.ContentRef | undefined
): ImageURISource | null {
    const theme = useConfigurationTheme();
    const contentRef = (theme.color === 'light' ? null : contentRefDark) || defaultContentRef;

    const resolved = useContentReference(contentRef);

    if (!resolved.href) {
        return null;
    }

    const file = resolved.resolution?.extra?.file;

    return {
        uri: resolved.href,
        width: file?.dimensions?.width,
        height: file?.dimensions?.height,
    };
}
